import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import React from 'react'
import LogoPersonalArchitect from '../../assets/svg/logos/primary/personal-architect-horizontal.svg'
import { Launch } from '@mui/icons-material'

const Header = (props) => {
  return (
    <AppBar position="static" color="white">
      <Toolbar sx={{alignItems: "center", display: "flex",}}>
        <Box component="img" src={LogoPersonalArchitect} width={220} height={40} />
        <Typography fontFamily="Readex Pro Variable" fontWeight={500} sx={{ml:1,}} textTransform="uppercase">| Garages</Typography>
        <Box sx={{display: "flex", flex: 1,}} />
        <IconButton color="primary" href="https://designer.personalarch.com/" target="_blank">
          <Launch />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

export default Header